import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { placementRationale } from '../../data/onboardingData';
import { student } from '../../data/mockData';

const { FiArrowRight, FiBookOpen, FiInfo } = FiIcons;

function PlacementStep({
  recommendations,
  onComplete
}) {
  return (
    <div>
      <span className="eyebrow">For the parent</span>
      <h1 className="mt-3 font-['Manrope'] text-3xl font-bold tracking-[-0.04em] text-[#24302d]">
        {student.name} is ready to begin
      </h1>
      <p className="mt-3 max-w-xl text-sm leading-6 text-[#6c7773]">
        Based on the diagnostic, these are the recommended starting points
        within the confirmed 7th-grade curriculum.
      </p>

      <div className="mt-7 grid gap-3 sm:grid-cols-2">
        {recommendations.map(({ subject, lesson }) => (
          <article
            className="rounded-2xl border border-[#e3e4de] bg-[#faf9f6] p-5"
            key={lesson.id}
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#e6f0ec] text-[#4f776d]">
              <SafeIcon icon={FiBookOpen} />
            </span>
            <span className="mt-4 block text-[10px] font-bold uppercase tracking-[0.1em] text-[#5b21b6]">
              {subject}
            </span>
            <strong className="mt-1 block text-base text-[#24302d]">
              {lesson.title}
            </strong>
            <p className="mt-2 text-xs leading-5 text-[#6c7773]">
              {lesson.description}
            </p>
          </article>
        ))}
      </div>

      <div className="mt-6 rounded-xl bg-[#e6f0ec] p-4 text-sm leading-6 text-[#47645d]">
        <div className="flex gap-3">
          <SafeIcon className="mt-1 shrink-0" icon={FiInfo} />
          <div>
            <p>{placementRationale}</p>
            <p className="mt-2 font-semibold">
              This diagnostic refines where your student starts within 7th
              grade — it does not change their grade level.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-8 flex justify-end">
        <button
          className="flex items-center gap-2 rounded-xl bg-[#7c3aed] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#5b21b6]"
          onClick={onComplete}
          type="button"
        >
          Go to Dashboard
          <SafeIcon icon={FiArrowRight} />
        </button>
      </div>
    </div>
  );
}

export default PlacementStep;